export function ImportAllLogos() {
	const path = require.context('../../../public/ClientIcons/', false, /\.(png|jpe?g|svg)$/)
	let images = {};
		path.keys().forEach((item, index) => { images[item.replace('./', '')] = path(item); });
	return images
}